import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'
import Actions from './utils/actions'

const RESOURCE_NAME = 'cotaProinfa'

const endpoint = (action, id) => {
  switch (action) {
    case Actions.INDEX:
    case Actions.CREATE:
      return `/acl/perfis/${id}/cotas_proinfa`

    case Actions.SHOW:
    case Actions.UPDATE:
    case Actions.DESTROY:
      return `/acl/cotas_proinfa/${id}`

    default:
      return ''
  }
}

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingCotaProinfaSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingCotaProinfaSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_COTA_PROINFA_SUCCESS = 'LOADING_COTA_PROINFA_SUCCESS'
export function loadingCotaProinfaSuccess(cotaProinfa) {
  return {
    type: LOADING_COTA_PROINFA_SUCCESS,
    cotaProinfa,
  }
}

export const DESTROYING_COTA_PROINFA_SUCCESS = 'DESTROYING_COTA_PROINFA_SUCCESS'
export function destroyingCotaProinfaSuccess(cotaProinfaId) {
  return {
    type: DESTROYING_COTA_PROINFA_SUCCESS,
    cotaProinfaId,
  }
}

export function fetchMultipleCotaProinfa(parentId) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.INDEX, parentId)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchCotaProinfa(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.SHOW, id)).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createCotaProinfa(parentId, cotaProinfa) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(
      endpoint(Actions.CREATE, parentId),
      'POST',
      cotaProinfa
    ).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateCotaProinfa(id, cotaProinfa) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(endpoint(Actions.UPDATE, id), 'PUT', cotaProinfa).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyCotaProinfa(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(endpoint(Actions.DESTROY, id), 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const cotaProinfa = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_COTA_PROINFA_SUCCESS: {
      const { cotaProinfa: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_COTA_PROINFA_SUCCESS:
      return state.delete(action.cotaProinfaId.toString())

    default:
      return state
  }
}

export default cotaProinfa
